export default "__VITE_ASSET__Cu4pNIgx__"